import { useLocation } from 'react-router-dom';

/**
 * Resolve the ID of the side menu item selected
 *
 * @returns The menu ID
 */
export function useSideMenuId(): string | undefined {
  const { hash } = useLocation();
  return hash ? hash.slice(1) : undefined;
}
